import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[flex-spacer], flex-spacer, [flexSpacer]',
    standalone: true,
})
export class FlexSpacerDirective
{
    @HostBinding('style.flex') flexValues = '1 1 auto';
}
